import {UseQueryResult, useQuery} from "@tanstack/react-query";
import {useSearchParams} from "react-router-dom";

import {getCompanyLocations} from "./RegistrationService";
import {CompanyLocationsResponse} from "./types/CompanyLocations";

export default function useCompanyLocations(): UseQueryResult<
  CompanyLocationsResponse,
  Error
> {
  const [searchParams] = useSearchParams();

  return useQuery<CompanyLocationsResponse, Error>({
    queryKey: [
      "locations",
      searchParams.get("company"),
      searchParams.get("operator"),
    ],
    queryFn: () =>
      getCompanyLocations(
        searchParams.get("company") as string,
        searchParams.get("operator") as string
      ),
    enabled: Boolean(
      searchParams.get("company") && searchParams.get("operator")
    ),
  });
}
